import Swiper from 'swiper/bundle';

export default function initSwiperSingleProjet(playersInstance) {
    const swiperSingleProjetContainer = document.querySelector(".swiperSingleProjet");

    if (swiperSingleProjetContainer) {
        playersInstance.swiperSingleProjet = new Swiper(".swiperSingleProjet", {
            slidesPerView: 'auto',
            spaceBetween: 10,
            loop: false,
            breakpoints: {
                1200: {
                    spaceBetween: 30,
                },
            },
            watchSlidesProgress: true,
            navigation: {
                nextEl: ".block-single-post-content .swiper-next",
                prevEl: ".block-single-post-content .swiper-prev",
            },
            on: {
                slideChange: () => {
                    playersInstance.pauseCurrentVideo();
                    playersInstance.removePlayingClass();
                },
                beforeChange: () => {
                    playersInstance.pauseCurrentVideo();
                    playersInstance.removePlayingClass();
                },
            },
        });
    }
}
